module.exports = __webpack_public_path__ + "media/images/success-stories-5-34c737cac529a35bec187027f80c260b.jpeg";